// @flow
import React from 'react';
import * as Homie from 'styles/Home/StyledHome';
import $_ from 'jquery';
import _ from 'lodash';
import StepperComponent from 'components/shared/StepperComponent';
import ApplicationContent from 'components/renter_application/ApplicationContentComponent';
import ResumeContentComponent from 'components/renter_application/ResumeContentComponent';
import CanceledHomeApplicationModal from 'components/CanceledHomeApplicationModalComponent';
import CancelHomieApplicationConfirmationModal from 'components/CancelHomieApplicationConfirmationModalComponent';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import HomeApplication from 'models/HomeApplication';
import HomieContext from 'HomieContext';
import ApplicationSteps from './ApplicationStepsComponent';
import Step from 'models/Step';
import {
  StepperContentWrapper,
  StepperContent,
  WrapperSpinner
} from 'styles/Steppers';
import Spinner from 'components/shared/Spinner';
import { Redirect } from 'react-router-dom';
import CurrentUserAction from 'actions/CurrentUserActions';
import swal from '@sweetalert/with-react';
import ModalAutoCloseComponent from 'components/ModalAutoCloseComponent';
import Accordion from 'views/AccordionComponent';
import { MainHelp } from 'components/help/home_application/UserHelp';
import {
  HOME_APPLICATION_STEPPER_ITEMS,
  HOME_APPLICATION_STEPPER_ITEMS_EXT,
  STEPSURL,
  LEGAL_STEPSURL,
  STEPSURL_EXT,
  LEGAL_STEPSURL_EXT
} from 'utils/Constants';
import SuccessProcess from 'modules/external_tenant/components/SuccessProcessComponent';
import ModalSuccessProcess from 'modules/external_tenant/components/ModalSuccessProcessComponent';
import AuthenticationAction from 'actions/AuthenticationAction';
import CancelProcess from 'modules/external_tenant/components/CancelProcessComponent';
const SuccessMessage =
  'Hemos recibido correctamente tu información, pronto tendrás respuesta sobre tu acreditación como inquilino Homie';
const STEPS = {
  account: 0,
  profile: 1,
  income: 2,
  references: 3,
  documents: 4,
  payment: 5,
  resume: 10,
  complete: 10,
  previous_landlord: 10,
  extra: 10
};

const LEGAL_STEPS = {
  account: 0,
  profile: 1,
  income: 2,
  references: 3,
  documents: 4,
  payment: 5,
  resume: 10,
  complete: 10,
  previous_landlord: 10,
  extra: 10
};

type PropsType = {
  match: {
    params: {
      home_id: string,
      home_app_id: string,
      step: string
    }
  },
  location: any,
  history: any,
  app_type?: string
};

type StateType = {
  homeApplication?: HomeApplication | null,
  selectedIndex: number,
  steps: Array<Step>,
  langSelected: string,
  typePersonSelected: string | typeof undefined,
  resumingIsPending: boolean,
  isFromAgency: boolean,
  visibleFormBill: boolean,
  homeId: string,
  showCancelExternalApplicationConfirmationModal: boolean,
  showCancelHomieApplicationConfirmationModal: boolean,
  showCanceledApplicationModal: boolean,
  redirectToApplicationsIndex: boolean,
  parameterIndexStep: number,
  creatingHomeApp: boolean,
  visibleModalNotFound: boolean,
  appType: string,
  appFinished: boolean,
  isDesktop: boolean
};

class RenterApplication extends React.Component<PropsType, StateType> {
  state = {
    selectedIndex: 0,
    steps: HOME_APPLICATION_STEPPER_ITEMS,
    langSelected: 'es',
    typePersonSelected: undefined,
    resumingIsPending: false,
    isFromAgency: false,
    visibleFormBill: false,
    homeId: '',
    homeApplication: undefined,
    showCancelExternalApplicationConfirmationModal: false,
    showCancelHomieApplicationConfirmationModal: false,
    showCanceledApplicationModal: false,
    redirectToApplicationsIndex: false,
    stepFromUrl: 0,
    parameterIndexStep: '',
    creatingHomeApp: false,
    visibleModalNotFound: false,
    appType: this.initialAppType,
    appFinished: false,
    isDesktop: false,
    isLoading: false
  };

  get initialAppType() {
    return this.props.app_type === 'externo' ? 'externo' : '';
  }

  isHomieFlow = (): boolean => this.props.app_type !== 'externo';

  componentWillMount = (): void => {
    HomeApplicationStore.addChangeListener(this.setHomeApplication);
    HomeApplicationStore.addCancelChangeListener(() => {
      if (this.isHomieFlow()) this._showCanceledHomeApplicationModal();
    });
    const { home_id, home_app_id, step } = this.props.match.params;
    if (home_app_id) {
      this.setState({ isLoading: true }, () => {
        HomeApplicationActions.editHomeApplication(
          home_app_id,
          this.errorEditHomeApp
        );
      });
    } else {
      this.setState(
        prevState => {
          if (step) prevState.stepFromUrl = step;
          prevState.creatingHomeApp = true;
          return prevState;
        },
        () => {
          HomeApplicationActions.createHomeApplication({
            home_application: {
              home_id: home_id
            }
          });
        }
      );
    }
    CurrentUserAction.startCurrentUserPolling();
    window.addEventListener('resize', this.checkWidth);
  };

  errorEditHomeApp = (): void => {
    this.setState({
      visibleModalNotFound: true
    });
  };

  componentDidMount = (): void => {
    $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
    if (this.props.match.params.home_id == undefined) {
      this.validationStep();
    }
    if (this.state.isFromAgency) {
      let { steps } = this.state;
      steps[0].name = 'Cuenta';
      this.setState({ steps: steps });
    }
    const { home_id } = this.props.match.params;
    this.setState({ homeId: home_id });
    this.checkWidth();
  };

  componentWillUnmount() {
    HomeApplicationStore.removeCancelChangeListener(this.setHomeApplication);
    HomeApplicationStore.removeCancelChangeListener(
      this._showCanceledHomeApplicationModal
    );
    window.removeEventListener('resize', this.checkWidth);
  }

  callbackSetCurrentPosition = (position: number): void => {
    return null;
  };

  stepperNextStep = (): void => {
    let actualIndex = this.state.selectedIndex;
    if (this.state.selectedIndex + 1 < this.state.steps.length) {
      this.setState(
        () => {
          return { selectedIndex: actualIndex + 1 };
        },
        () => {
          $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
        }
      );
    }
  };

  validateOrderStep = (selectedIndex: number): void => {
    const { homeApplication, appType } = this.state;
    let FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL;
    let FINAL_USE_STEPSURL = STEPSURL;

    if (appType === 'externo') {
      FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL_EXT;
      FINAL_USE_STEPSURL = STEPSURL_EXT;
    }

    const FINAL_STEPSURL =
      homeApplication.person_type === 'moral'
        ? FINAL_USE_LEGAL_STEPSURL
        : FINAL_USE_STEPSURL;
    let parameterIndexStep = FINAL_STEPSURL.findIndex(
      element => element === selectedIndex
    );
    this.setState({
      parameterIndexStep,
      creatingHomeApp: false
    });

    if (this.props.match.params.home_id) {
      this.props.history.push(
        `/inquilino/aplicaciones/${homeApplication.id}/editar/${FINAL_STEPSURL[selectedIndex]}`
      );
    } else {
      if (parameterIndexStep !== -1) {
        if (parameterIndexStep > selectedIndex) {
          if (
            this.props.location.pathname !==
            `/inquilino/aplicaciones/${homeApplication.id}/editar/${FINAL_STEPSURL[selectedIndex]}`
          ) {
            this.props.history.push(FINAL_STEPSURL[selectedIndex]);
          }
        } else {
          if (
            this.props.location.pathname !==
            `/inquilino/aplicaciones/${homeApplication.id}/editar/${FINAL_STEPSURL[parameterIndexStep]}`
          ) {
            this.props.history.push(FINAL_STEPSURL[parameterIndexStep]);
          }
        }
      } else if (
        homeApplication.status !== 'screening' &&
        homeApplication.status !== 'pending_payment'
      ) {
        this.props.history.push(FINAL_STEPSURL[selectedIndex]);
      }
    }
  };

  updateUrlRedirect = (selectedIndex): void => {
    const { appType } = this.state;

    let FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL;
    let FINAL_USE_STEPSURL = STEPSURL;

    if (appType === 'externo') {
      FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL_EXT;
      FINAL_USE_STEPSURL = STEPSURL_EXT;
    }

    const FINAL_STEPSURL =
      this.state.homeApplication.person_type === 'moral'
        ? FINAL_USE_LEGAL_STEPSURL
        : FINAL_USE_STEPSURL;
    if (
      this.props.location.pathname !==
      `/inquilino/aplicaciones/${this.state.homeApplication.id}/editar/${FINAL_STEPSURL[selectedIndex]}`
    )
      this.props.history.replace(FINAL_STEPSURL[selectedIndex]);
  };

  linkToInTabs = (indexStep: number): void => {
    const FINAL_STEPSURL =
      this.state.homeApplication.person_type === 'moral'
        ? LEGAL_STEPSURL
        : STEPSURL;
    if (indexStep <= this.state.selectedIndex) {
      this.props.history.replace(FINAL_STEPSURL[indexStep]);
    }
    this.setState({
      parameterIndexStep: indexStep
    });
  };

  stepperPrevStep = (): void => {
    this.updateUrlRedirect(this.state.parameterIndexStep - 1);
    let parameterIndexStep = this.state.parameterIndexStep - 1;
    this.setState({
      parameterIndexStep
    });
  };

  setHomeApplication = (): void => {
    let homeApp = HomeApplicationStore.getHomeApplication();
    if (
      homeApp.agency &&
      (this.isScreeningApplication(homeApp.status) ||
        this.isDocumentsRequested(homeApp.status))
    )
      return (window.location.href = `/home_applications/${homeApp.id}/edit`);
    this.setState(
      {
        homeApplication: homeApp,
        isLoading: false
      },
      () => {
        this.typePersonSelected(homeApp);
        this.selectIndex(homeApp);
        this.isApplicationFinished(this.state.appType, homeApp.step);
      }
    );
  };

  updateOnlyIncome = (value: {}) => {
    this.setState(value, () => {
      this.updateHomeApplication(value, true);
    });
  };

  updateAllSteps = (value: {}) => {
    this.setState(value, () => {
      this.updateHomeApplication(value);
    });
    const FINAL_STEPS =
      this.state.homeApplication.person_type === 'moral' ? LEGAL_STEPS : STEPS;
    const selectedIndex =
      this.state.homeApplication !== null
        ? FINAL_STEPS[this.state.homeApplication.step]
        : 0;
    this.setState({
      selectedIndex
    });
  };

  handleChange = (value: {}): void => {
    this.isOnlyEditIncome()
      ? this.updateOnlyIncome(value)
      : this.updateAllSteps(value);
  };

  _handleResumeApp = (): void => {
    this.setState({ resumingIsPending: false });
  };

  _closeCanceledHomeApplicationModal = (): void => {
    let status = this.isHomieFlow();

    this.setState(() => {
      return {
        showCanceledApplicationModal: false,
        redirectToApplicationsIndex: status
      };
    });
  };

  isTheStepVisible = (
    indexRequired: number,
    typePersonSelectedRequired: string | null,
    isFromAgencyRequired: boolean | null = null
  ): boolean => {
    const { appType } = this.state;

    let FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL;
    let FINAL_USE_STEPSURL = STEPSURL;

    if (appType === 'externo') {
      FINAL_USE_LEGAL_STEPSURL = LEGAL_STEPSURL_EXT;
      FINAL_USE_STEPSURL = STEPSURL_EXT;
    }

    const { step } = this.props.match.params;
    const FINAL_STEPSURL =
      this.state.homeApplication &&
      this.state.homeApplication.person_type === 'moral'
        ? FINAL_USE_LEGAL_STEPSURL
        : FINAL_USE_STEPSURL;
    let parameterIndexStep = FINAL_STEPSURL.findIndex(
      element => element === step
    );

    const selectStep = !this.isRedirectPageToApp()
      ? FINAL_STEPSURL.complete
      : this.state.selectedIndex;

    if (
      this.state.parameterIndexStep &&
      parameterIndexStep !== this.state.parameterIndexStep
    )
      this.setState({ parameterIndexStep });

    if (parameterIndexStep > selectStep || parameterIndexStep === -1)
      this.props.history.replace(FINAL_STEPSURL[selectStep]);

    let selectedIndex = FINAL_STEPSURL.findIndex(element => element === step);
    const isSelectedIndexRequired = selectedIndex === indexRequired;
    const isResumingPending = this.state.resumingIsPending;

    const personTypeAllowShowingStep =
      typePersonSelectedRequired === null ||
      typePersonSelectedRequired === this.state.typePersonSelected;

    const agencyAllowShowingStep =
      isFromAgencyRequired === null ||
      (isFromAgencyRequired !== null &&
        this.state.isFromAgency === isFromAgencyRequired);
    return (
      isSelectedIndexRequired &&
      !isResumingPending &&
      personTypeAllowShowingStep &&
      agencyAllowShowingStep
    );
  };

  setVisibleFormBill = (boolean: boolean): void => {
    this.setState({ visibleFormBill: boolean });
  };

  validationStep = (): void => {
    let stepViewApplication = [
      'account',
      'profile',
      'income',
      'references',
      'documents',
      'verification',
      'payment'
    ];
    if (
      this.state.homeApplication &&
      this.state.homeApplication.person_type === 'moral'
    ) {
      stepViewApplication = [
        'account',
        'profile',
        'income',
        'references',
        'documents',
        'payment'
      ];
    }
    let { state } = this.props.location;

    if (state) {
      if (stepViewApplication.includes(state.step)) {
        this.setState({
          selectedIndex: this.props.location.state.stepIndexApplication
        });
      }
      if (_.has(this.props.location.state, 'visibleFormBill')) {
        this.setVisibleFormBill(true);
      }
    }
  };

  _handleCancelApplication = (): void => {
    const ha_id = _.get(this.state.homeApplication, 'id');
    const u_id = _.get(this.context.currentUser, 'id');

    if (ha_id && u_id && this.isHomieFlow()) {
      this.setState({
        showCancelHomieApplicationConfirmationModal: true
      });
    }

    if (ha_id && u_id && !this.isHomieFlow()) {
      this.setState({
        showCancelExternalApplicationConfirmationModal: true
      });
    }
  };

  _cancelHomieApplication = () => {
    this._showCanceledHomeApplicationModal(() => {
      const ha_id = _.get(this.state.homeApplication, 'id');
      const u_id = _.get(this.context.currentUser, 'id');
      HomeApplicationStore.flushAssets();
      HomeApplicationActions.cancelHomeApplication(ha_id, u_id);
    });
  };

  _showCanceledHomeApplicationModal = (
    callback?: Function = () => {}
  ): void => {
    this.setState(() => {
      return {
        showCancelExternalApplicationConfirmationModal: false,
        showCancelHomieApplicationConfirmationModal: false,
        showCanceledApplicationModal: true
      };
    }, callback);
  };

  updateHomeApplication = (values: any, isOnlyIncome: boolean = false) => {
    const { appType } = this.state;
    const id = _.get(this.state.homeApplication, 'id');
    const step = _.get(this.state.homeApplication, 'step');
    const serializedObject = HomeApplication.serializeForBackend(
      _.assign({ id, step: 'account' }, values)
    );
    this.context.showLoadingProcessView();
    if (isOnlyIncome) {
      this.saveHomeApplicationIncome(id, serializedObject, step, appType);
    } else {
      this.saveHomeApplicationData(id, serializedObject, step, appType);
    }
  };

  saveHomeApplicationData = (
    id: string,
    serializedObject: Object,
    step: string,
    appType: string
  ) => {
    HomeApplicationActions.updateHomeApplication(
      id,
      serializedObject,
      () => {
        this.context.hideLoadingProcessView();
        this.isApplicationFinished(appType, step);
        $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
      },
      this.errorUpdateHomeApp
    );
  };

  saveHomeApplicationIncome = (
    id: string,
    serializedObject: Object,
    step: string,
    appType: string
  ) => {
    HomeApplicationActions.updateHomeApplication(
      id,
      serializedObject,
      () => {
        this.context.hideLoadingProcessView();
        this.props.history.push('/inquilino/aplicaciones');
      },
      this.errorUpdateHomeApp
    );
  };

  errorUpdateHomeApp = (): void => {
    let error = HomeApplicationStore.getUpdateHomeApplicationError().error;
    swal('¡Algo salió mal!', error, 'error').then(value => {
      window.open('/h/inquilino/aplicaciones/', '_self');
    });
  };

  typePersonSelected = (homeApp: HomeApplication) => {
    const { appType } = this.state;
    let finalSteps =
      appType === 'externo'
        ? HOME_APPLICATION_STEPPER_ITEMS_EXT
        : HOME_APPLICATION_STEPPER_ITEMS;
    if (homeApp.person_type && homeApp.person_type === 'moral')
      finalSteps = finalSteps.filter(function(step) {
        return step.slug !== 'verification';
      });
    this.setState({
      typePersonSelected: homeApp.person_type,
      steps: finalSteps
    });
  };

  selectIndex = (homeApp: HomeApplication): void => {
    const FINAL_STEPS =
      this.state.homeApplication.person_type === 'moral' ? LEGAL_STEPS : STEPS;
    let selectedIndex = homeApp !== null ? FINAL_STEPS[homeApp.step] : 0;
    this.setState({
      selectedIndex,
      parameterIndexStep: selectedIndex
    });
    this.validateOrderStep(selectedIndex);
  };

  shouldRedirectToHomeApplicationIndex = (): boolean => {
    const { homeApplication } = this.state;
    const { currentUser } = this.context;
    const redirectStatuses = ['approved', 'declined', 'canceled'];
    const redirectSteps = [
      'resume',
      'previous_landlord',
      'extra',
      'verification'
    ];

    if (
      _.isUndefined(homeApplication) ||
      _.isNull(homeApplication) ||
      _.isEmpty(homeApplication) ||
      currentUser.isAdmin
    ) {
      return false;
    }
    return _.includes(
      redirectStatuses,
      _.get(homeApplication, 'status') ||
        _.includes(redirectSteps, _.get(homeApplication, 'step'))
    );
  };

  setModalVisibleNotFound = (value: boolean): void => {
    const { appType } = this.state;
    this.setState({
      visibleModalNotFound: value
    });
    if (appType === 'externo') this.props.history.push('/inquilinos-externos');
    else this.props.history.push('/inquilino/aplicaciones');
  };

  checkWidth = () => {
    const match = window.matchMedia(`(min-width: 992px)`);
    if (match.matches) {
      this.setState({ isDesktop: true });
    } else {
      this.setState({ isDesktop: false });
    }
  };

  redirectApplicationComplete = () => {
    const u_id = _.get(this.context.currentUser, 'id');
    const { id } = this.state.homeApplication;
    this.props.history.push(
      `/inquilinos-externos/${u_id}/aplicaciones/${id}/completada`
    );
  };

  isApplicationFinished = (appType: string, step: string) => {
    if (appType === 'externo' && step === 'complete') {
      this.setState({
        appFinished: true
      });
    }
  };

  renderHelpComponent = () => {
    if (this.state.appType === 'externo') {
      return null;
    }

    return (
      <Homie.HelpRightContainer
        style={{ height: 'max-content', marginLeft: '15px' }}
      >
        <Homie.HelpRightSideHeader>
          Resolvemos todas tus dudas…
        </Homie.HelpRightSideHeader>
        <Homie.HelpRightSideBody>
          <Accordion questions={MainHelp} />
        </Homie.HelpRightSideBody>
      </Homie.HelpRightContainer>
    );
  };

  onLogout = () => {
    AuthenticationAction.logout(response => {
      this.props.history.push('/inquilinos-externos');
      if (response && response.csrf) {
        swal({
          className: 'logout',
          icon: '',
          title: 'Has salido del sistema',
          timer: 5000,
          button: {
            text: 'OK',
            value: true,
            visible: true,
            closeModal: true
          }
        });
      }
    });
  };

  onCancelHomeApplication = () => {
    this._showCanceledHomeApplicationModal(() => {
      const homeApplicationId = _.get(this.state.homeApplication, 'id');
      const userId = _.get(this.context.currentUser, 'id');
      HomeApplicationStore.flushAssets();
      HomeApplicationActions.cancelHomeApplication(
        homeApplicationId,
        userId,
        () => {
          _.delay(this.onLogout, 5000);
        }
      );
    });
  };

  _closesCancelExternalApplicationConfirmationModal = () => {
    this.setState({
      showCancelExternalApplicationConfirmationModal: false
    });
  };

  _closeCancelHomieApplicationConfirmationModal = () => {
    this.setState({
      showCancelHomieApplicationConfirmationModal: false
    });
  };

  isCompletedApplication = (homeApplicationStep: string) =>
    homeApplicationStep === 'complete';

  isScreeningApplication = (homeApplicationStatus: string) =>
    homeApplicationStatus == 'screening';

  isDocumentsRequested = (homeApplicationStatus: string) =>
    homeApplicationStatus == 'documents_requested';

  isRedirectPageToApp = (): boolean => {
    if (this.isAdminOrAdvisor()) return false;

    const { homeApplication } = this.state;
    const { step } = this.props.match.params;
    if (homeApplication)
      return (
        this.isCompletedApplication(homeApplication.step) && step !== 'ingresos'
      );
  };

  isAdminOrAdvisor = () => {
    const { currentUser } = this.context;
    return (
      currentUser.roles.includes('admin') ||
      currentUser.roles.includes('super_admin') ||
      currentUser.roles.includes('agent')
    );
  };

  isOnlyEditIncome = (): boolean => {
    const { homeApplication } = this.state;
    if (!homeApplication || this.isAdminOrAdvisor()) return false;

    return (
      this.isCompletedApplication(homeApplication.step) &&
      (this.isScreeningApplication(homeApplication.status) ||
        this.isDocumentsRequested(homeApplication.status))
    );
  };

  render() {
    const {
      homeApplication,
      showCancelExternalApplicationConfirmationModal,
      showCancelHomieApplicationConfirmationModal,
      showCanceledApplicationModal,
      redirectToApplicationsIndex,
      steps,
      creatingHomeApp,
      appType,
      isLoading
    } = this.state;
    const { match, history } = this.props;

    if ((creatingHomeApp && match.params.home_id) || isLoading) {
      return (
        <WrapperSpinner>
          <Spinner />
        </WrapperSpinner>
      );
    }
    let redirect = this.shouldRedirectToHomeApplicationIndex();
    if (
      (redirect || redirectToApplicationsIndex || this.isRedirectPageToApp()) &&
      this.isHomieFlow()
    ) {
      return <Redirect to={`/inquilino/aplicaciones/`} />;
    }

    if (this.state.appFinished) {
      return (
        <Homie.Container>
          <Homie.Content>
            <Homie.Wrapper>
              {this.state.isDesktop ? (
                <ModalSuccessProcess
                  title="¡Listo!"
                  message={SuccessMessage}
                  show={true}
                  timerClose={5000}
                  autoClose={this.state.appFinished}
                  handleCloseModal={() => this.redirectApplicationComplete()}
                />
              ) : (
                <SuccessProcess
                  title="¡Listo!"
                  message={SuccessMessage}
                  handleClose={this.redirectApplicationComplete}
                />
              )}
            </Homie.Wrapper>
          </Homie.Content>
        </Homie.Container>
      );
    }

    if (!homeApplication) {
      return (
        <Homie.Container>
          <Homie.Content>
            <Homie.Wrapper>
              <ModalAutoCloseComponent
                message="Lo sentimos, no se encuentra la aplicación"
                show={this.state.visibleModalNotFound}
                timerClose={5000}
                autoClose={true}
                handleCloseModal={() => this.setModalVisibleNotFound(false)}
                icon="🙁"
              />
            </Homie.Wrapper>
          </Homie.Content>
        </Homie.Container>
      );
    }
    return (
      <Homie.Container>
        {showCancelHomieApplicationConfirmationModal && (
          <CancelHomieApplicationConfirmationModal
            visible={true}
            onClickButtonContinue={
              this._closeCancelHomieApplicationConfirmationModal
            }
            onClickButtonCancel={this._cancelHomieApplication}
          />
        )}

        {showCancelExternalApplicationConfirmationModal &&
          !this.isHomieFlow() && (
            <CancelProcess
              show={true}
              title="¿Estas seguro que deseas cancelar la aplicación para este departamento?"
              message="Continuar la aplicación"
              handleCloseModal={
                this._closesCancelExternalApplicationConfirmationModal
              }
              onClickButtonCancel={this.onCancelHomeApplication}
            />
          )}

        {showCanceledApplicationModal && (
          <CanceledHomeApplicationModal
            visible={true}
            close={this._closeCanceledHomeApplicationModal}
            autocloseTiming={5000}
          />
        )}

        <Homie.Wrapper
          paddingTop={this.state.appType === 'externo' ? '0' : false}
        >
          <StepperComponent
            stepsData={steps}
            selectedIndex={this.state.selectedIndex}
            onSetCurrentPosition={this.callbackSetCurrentPosition}
            freeNavigation={true}
            parameterIndexStep={this.state.parameterIndexStep}
            id={this.state.homeApplication ? this.state.homeApplication.id : ''}
            linkToInTabs={this.linkToInTabs}
            isFromExternalTenant={appType === 'externo'}
            isOnlyEditIncome={this.isOnlyEditIncome()}
          />
          <StepperContentWrapper
            justifyContent={appType === 'externo' ? 'center' : 'normal'}
          >
            {this.isTheStepVisible(0, null) && (
              <StepperContent>
                <ApplicationContent
                  handleChange={this.handleChange}
                  onCancel={this._handleCancelApplication}
                  langSelected={this.state.langSelected}
                  typePersonSelected={this.state.typePersonSelected}
                />
              </StepperContent>
            )}
            {!_.isUndefined(_.get(homeApplication, 'id')) && (
              <ApplicationSteps
                homeApplication={homeApplication}
                langSelected={this.state.langSelected}
                typePersonSelected={this.state.typePersonSelected}
                visibleFormBill={this.state.visibleFormBill}
                onHomeApplicationChange={this.handleChange}
                onHomeApplicationCancel={this._handleCancelApplication}
                isTheStepVisible={this.isTheStepVisible}
                onNextStep={this.stepperNextStep}
                onPrevStep={this.stepperPrevStep}
                prevStepText={
                  steps[this.state.parameterIndexStep - 1]
                    ? steps[this.state.parameterIndexStep - 1].name
                    : undefined
                }
                homeId={this.state.homeId}
                appType={this.state.appType}
                isOnlyEditIncome={this.isOnlyEditIncome()}
                match={match}
                history={history}
              />
            )}
            <StepperContent
              className={this.state.resumingIsPending ? 'visible' : 'hidden'}
            >
              <ResumeContentComponent
                cancelAction={() => {}}
                resumeAction={this._handleResumeApp}
              />
            </StepperContent>
            {this.renderHelpComponent()}
          </StepperContentWrapper>
        </Homie.Wrapper>
      </Homie.Container>
    );
  }
}
RenterApplication.contextType = HomieContext;
export default RenterApplication;
